import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DriversTable from '../drivers-table.jsx';


if (document.getElementById(
  'react-component-g4-logistics-portal-drivers-schedules')) {
  ReactDOM.render(
    <DriversTable
      url="/api/v1/portal/drivers/all-for-drivers-table"
      isLoading={true}
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-drivers-schedules'));
}
